/**
 * CSV一括(ダウンロードジョブ)管理ページ用のスクリプト
 */
if (is_route('csv_download_job.index')) {
    // aria-hiddenを無効にする(表示非表示制御でHTMLエラーを出力しているため)
    $('div[aria-hidden="ture"]').removeAttr('aria-hidden');
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        csv_download_job_event_set();
        csv_download_job_setting_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.csv_download_job_event_set = function()
{
    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true, function(){
            let model = $('#csv_download_job-setting-modal select[name="model"]').val();
            if (model.length === 0) {
                $('#conditions-area .condition-block').addClass('d-none');
            } else {
                $('#conditions-area #' + model).removeClass('d-none');
            }
        });
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        let modalId = create_id($(this).data('save-modal'));
        let modal = $(modalId);
        let model = modal.find('select[name="model"] option:selected').val();
        let driveReport = $(modalId).find('#drive_report');
        // 運行日誌の時、月毎＆月合計＆車両＆稼働率の算出時に「運行開始」「運行終了」のみの記録を含むがONの時、祝日日数をパラメータに追加する
        if (model === 'drive_report') {
            if (driveReport.find('input[name="type"]').val() === 'monthly'
                && driveReport.find('input[name="csv_type"]:checked').val() === 'total'
                && driveReport.find('input[name="mode"]').val() === 'vehicle'
                && driveReport.find('input[name="working_rate_mode"]:checked').val() === '1') {
                let holidays = getHolidayCountOnYearMonth($(modalId).find('#drive_report input[name="month"]').val(), ['Sunday','Saturday']);
                driveReport.find('input[name="notSatSunHolidayCount"]').val(holidays);
            } else {
                driveReport.find('input[name="notSatSunHolidayCount"]').val('');
            }
        }
        // POST
        _modal.submit(this, 'save-modal', function(results) {
        },function(xhr, status, errorThrown) {
            // 同名項目があるため、別途、model毎にメッセージを表示する。
            _error.set(modalId, xhr, status, errorThrown, false, false, model);
        });
    });

    /*---- 削除確認の表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-confirm-modal]', function () {
        // 設定モーダルを表示
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- リトライ確認の表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-retry_confirm-modal]', function () {
        // 設定モーダルを表示
        _modal.create(this, 'retry_confirm-modal', ['id']);
    });

    /*---- リトライ時 ----*/

    // リトライ実行時
    $(document).on('click', '[data-retry-modal]', function () {
        _modal.submit(this, 'retry-modal');
    });

    /*---- ダウンロードボタンクリック時、アイコンの色を変える ----*/

    // DL実行時
    $(document).on('click', 'a.file-download', function () {
        // バッジの見た目カウントダウンしておく
        let configBadge = $('span.badge-newer-config');
        let csvDownloadJobBadge = $('span.badge-newer-csv_download_job');
        configBadge.html(configBadge.html() - 1);
        csvDownloadJobBadge.html(csvDownloadJobBadge.html() - 1);
        // ダウンロード済み表示
        $(this).parent('td').siblings('td.download-status').html('済');
    });

}

window.csv_download_job_setting_event_set = function()
{
    // setting内での共通変数
    let modalIdText = 'csv_download_job-setting-modal';
    let modalId = create_id(modalIdText);
    let monthLimit = {  // month
        'measurement_latest': 13,
        'measurement': 13,
        'drive_report': 13,
        'daily_check_result': 13,
        'refuel': 13,
    };

    /*----
    測定結果・測定結果詳細のワンボタン抽出出し分け処理
    ----*/

    let controlSearchTypeByPageConfig = function(modelId, params, action)
    {
        // 測定結果・測定結果詳細のワンボタン抽出、「備考・指示事項」は会社設定で表示制御
        let search_type = $(modalId + ' #' + modelId + ' .search_type-switch');
        let searchType9 = search_type.find('label.btn-value-9');
        // 会社設定取得
        _ajax.post(action, params, function (results) {
            // 備考・指示事項の表示非表示
            if (searchType9.length > 0) {
                if (results.report_type === null
                    || results.report_type.measurement === 'undefined'
                    || results.report_type.measurement === '0') {
                    searchType9.removeClass('active').addClass('d-none').find('input').prop('checked', false);
                } else {
                    searchType9.removeClass('d-none');
                }
            }
            // デフォルトチェックしておく
            if (search_type.find('label.active').length === 0) {
                search_type.find('label').eq(0).addClass('active').find('input').prop('checked', true);
            }
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    }

    /*---- 会社選択時 ----*/

    $(document).off('change', modalId + '-company_id');
    $(document).on('change', modalId + '-company_id', function ()
    {
        // 会社のページ設定による測定結果・測定結果詳細のワンボタン抽出項目出し分け処理
        let modelId = $(modalId + '-model option:selected').val();
        if (modelId === 'measurement_latest' || modelId === 'measurement') {
            let search_type = $(modalId + ' #' + modelId + ' .search_type-switch');
            let searchType9 = search_type.find('label.btn-value-9');
            let searchType11 = search_type.find('label.btn-value-11');
            if ($(this).val() === '') {
                // ワンボタン ui init
                if (searchType9.length > 0) {
                    searchType9.removeClass('d-none');
                }
                if (searchType11.length > 0) {
                    searchType11.removeClass('active').addClass('d-none').find('input').prop('checked', false);
                }
            } else {
                if (searchType11.length > 0) {
                    searchType11.removeClass('d-none');
                }
                let params = {'id': $(this).val()};
                let action = $(this).data('page_config');
                controlSearchTypeByPageConfig(modelId, params, action);
            }
        }
    });

    /*---- 営業所選択時 ----*/

    $(document).off('change', modalId + '-section_id');
    $(document).on('change', modalId + '-section_id', function ()
    {
        if ($(this).val() === '') {
            $('.section-parts').addClass('d-none');
        } else {
            $('.section-parts').removeClass('d-none');
        }
    });

    /*---- model選択時 ----*/

    $(document).off('change', modalId + '-model');
    $(document).on('change', modalId + '-model', function ()
    {
        let selectedValue = $(this).val();
        let searchArea = $('#conditions-area .condition-block');
        // エラーメッセージクリア
        $('span.invalid-feedback').each(function() {
            if (!$(this).hasClass('copy')) {
                $(this).remove();
            }
        })
        // 抽出条件エリア表示制御
        searchArea.addClass('d-none');
        searchArea.find('input:hidden, select:hidden').prop('disabled', true);

        // モデル未選択(---)は抽出条件エリアを非表示
        if (selectedValue && selectedValue.trim()) {
            let selectSearchArea = $('#conditions-area #' + selectedValue);
            // 選択モデルの時抽出条件エリアのみ表示
            selectSearchArea.removeClass('d-none');
            selectSearchArea.find('input, select').prop('disabled', false);
        }

        // 運行日誌 出力CSV選択制御
        if (selectedValue === 'drive_report') {
            let driveReport = $(modalId).find('#drive_report');
            let csvType = $('#drive_report input[name="csv_type"]:checked');
            if (csvType.length === 0) { // デフォルトチェックされていない時があるため、補完
                csvType = $('#drive_report input[name="csv_type"]').eq(0).prop('checked', true);
            }
            let csvTypeVal = csvType.val();
            let modeVal = 'user';

            // 月合計CSV→車両選択状態チェック
            let modeVehicle = driveReport.find('#' + modalIdText + '-drive_report-mode_vehicle');
            if (csvTypeVal==='total' && modeVehicle.hasClass('active')) {
                modeVal = 'vehicle';
            }

            let dateTypeVal = 'monthly';
            // 表示パーツ切替 by csv_type
            driveReport.find('.csv_type-parts').addClass('d-none');
            driveReport.find('.csv_type-parts-' + csvTypeVal).removeClass('d-none');

            // mode制御
            if (csvTypeVal === 'detail' || csvTypeVal === 'total_by_vehicle') {
                modeVal = 'vehicle';
            }
            // 表示パーツ切替 by mode
            driveReport.find('.mode-parts').addClass('d-none');
            driveReport.find('.mode-parts-' + modeVal).removeClass('d-none');
            // 表示パーツ切替 by date_type
            driveReport.find('.date_type-parts').addClass('d-none');
            driveReport.find('.date_type-parts-' + dateTypeVal).removeClass('d-none');

            // 月合計、車両のみの表示項目
            if (csvTypeVal === 'total' && modeVal === 'vehicle') {
                driveReport.find('.total-vehicle-parts').removeClass('d-none');
            } else {
                driveReport.find('.total-vehicle-parts').addClass('d-none');
            }
        }

        // 給油情報 --- 出力CSV選択制御
        if (selectedValue === 'refuel') {
            let refuel = $(modalId).find('#refuel');
            let type = 'monthly';
            if (refuel.find('input[name="csv_type"]').val() === 'all') {
                type = 'all';
            }
            // 表示パーツ切替
            refuel.find('.type-parts').addClass('d-none');
            refuel.find('.type-parts input[type="text"]').not('.date-picker').not('.month-picker').val('');
            refuel.find('.type-parts-' + type).removeClass('d-none');
            if (type === 'monthly') {
                let mode = $('#refuel input[name="mode"]').val();
                refuel.find('.mode-parts').addClass('d-none');
                refuel.find('.mode-parts input[type="text"]').val('');
                refuel.find('.mode-parts-' + mode).removeClass('d-none');
            } else {
                refuel.find('.mode-parts').removeClass('d-none');
            }
        }

        // 出勤簿 CSV選択制御
        if (selectedValue === 'attendance') {
            let attendance = $(modalId).find('#attendance');
            let csvTypeVal = $('#attendance input[name="csv_type"]:checked').val();
            let mode = csvTypeVal === '3' ? 'year' : 'month';
            attendance.find('input[name="mode"]').val(mode);
            // 表示パーツ切替
            attendance.find('.mode-parts').addClass('d-none');
            attendance.find('.mode-parts input[type="text"]').not('.month-picker').not('.year-picker').val('');
            attendance.find('.mode-parts-'+ mode).removeClass('d-none');
        }

        // 測定結果 ワンボタン抽出出し分け処理
        if (selectedValue === 'measurement_latest' || selectedValue === 'measurement') {
            let company_id = $(modalId + '-company_id option:selected').val();
            let search_type = $(modalId + ' #' + selectedValue + ' .search_type-switch');
            let searchType9 = search_type.find('label.btn-value-9');
            let searchType11 = search_type.find('label.btn-value-11');
            if (company_id === '') {
                // ワンボタン ui init
                if (searchType9.length > 0) {
                    searchType9.removeClass('d-none');
                }
                if (searchType11.length > 0) {
                    searchType11.removeClass('active').addClass('d-none').find('input').prop('checked', false);
                }
            } else {
                if (searchType11.length > 0) {
                    searchType11.removeClass('d-none');
                }
                let params = {'id': company_id};
                let action = $(modalId + '-company_id').data('page_config');
                controlSearchTypeByPageConfig(selectedValue, params, action);
            }
        }
    });

    /*---- measurement/measurement_latest 検索方法切り替え時 ----*/

    $(document).off('change', '[id^="' + modalIdText + '-measurement-search_mode"],[id^="' + modalIdText + '-measurement_latest-search_mode"]');
    $(document).on('change', '[id^="' + modalIdText + '-measurement-search_mode"],[id^="' + modalIdText + '-measurement_latest-search_mode"]', function()
    {
        if($(this).val() === 'text') {
            $(this).parents('.search_mode').parent('div').find('.search_mode_text').removeClass('d-none');
            $(this).parents('.search_mode').parent('div').find('.search_mode_pulldown').addClass('d-none');
        } else if ($(this).val() === 'pulldown') {
            $(this).parents('.search_mode').parent('div').find('.search_mode_text').addClass('d-none');
            $(this).parents('.search_mode').parent('div').find('.search_mode_pulldown').removeClass('d-none');
        }
    });

    /*---- measurement/measurement_latest 検索期間自動補完 ----*/

    $(document).off('change', modalId + '-measurement-started_at,' + modalId + '-measurement_latest-started_at');
    $(document).on('change', modalId + '-measurement-started_at,' + modalId + '-measurement_latest-started_at', function()
    {
        let modelId = $(modalId + '-model option:selected').val();
        dateRange_changeStartedAt(this, modalId + '-' + modelId + '-ended_at', 0, monthLimit[modelId]);
    });

    $(document).off('change', modalId + '-measurement-ended_at,' + modalId + '-measurement_latest-ended_at');
    $(document).on('change', modalId + '-measurement-ended_at,' + modalId + '-measurement_latest-ended_at', function()
    {
        let modelId = $(modalId + '-model option:selected').val();
        dateRange_changeEndedAt(this, modalId + '-' + modelId + '-started_at', 0, monthLimit[modelId]);
    });

    /*---- drive_report csv_type選択時 ----*/

    $(document).off('change', '[id^="' + modalIdText + '-drive_report-csv_type"]');
    $(document).on('change', '[id^="' + modalIdText + '-drive_report-csv_type"]', function()
    {
        let driveReport = $(modalId).find('#drive_report');
        let csvTypeVal = $(this).val();
        let mode = $('#drive_report input[name="mode"]');
        let modeVal = mode.val() === '' ? 'user' : mode.val();

        // 表示パーツ切替 by csv_type
        driveReport.find('.csv_type-parts').addClass('d-none');
        driveReport.find('.csv_type-parts input[type="text"]').val('');
        driveReport.find('.csv_type-parts-' + csvTypeVal).removeClass('d-none');

        // 月明細CSVは車両のみ
        if (csvTypeVal === 'total') {
            modeVal = mode.val();
            // 月指定
            driveReport.find('.date_type-parts').addClass('d-none');
            driveReport.find('.date_type-parts-monthly').removeClass('d-none');
        } else if (csvTypeVal === 'detail') {
            // ボタン活性制御
            $(modalId + '-drive_report-mode_user').removeClass('active');
            $(modalId + '-drive_report-mode_vehicle').addClass('active');
            // 月明細
            modeVal = 'vehicle'
            mode.val(modeVal);
            // 月指定
            driveReport.find('.date_type-parts').addClass('d-none');
            driveReport.find('.date_type-parts-monthly').removeClass('d-none');
        } else if (csvTypeVal === 'total_by_vehicle') {
            modeVal = 'vehicle'
        }
        // 表示パーツ切替 by mode
        driveReport.find('.mode-parts').addClass('d-none');
        driveReport.find('.mode-parts input[type="text"]').val('');
        driveReport.find('.mode-parts-' + modeVal).removeClass('d-none');

        // 月合計、車両のみの表示項目
        if (csvTypeVal === 'total' && modeVal === 'vehicle') {
            driveReport.find('.total-vehicle-parts').removeClass('d-none');
        } else {
            driveReport.find('.total-vehicle-parts').addClass('d-none');
        }
    });

    /*---- drive_report mode(user/vehicle)選択時 ----*/

    $(document).off('change', '#drive_report input[name="mode"]');
    $(document).on('change', '#drive_report input[name="mode"]', function()
    {
        // drive_report,attendance,refuelのmodeとパラメタ名が同じため、
        // JSのiconボタン共通ロジックでイベントが発火する為、 modelがdrive_reportの時のみ処理するようにする。
        let modelId = $(modalId + '-model option:selected').val();
        if (modelId !== 'drive_report') {
            return;
        }

        let driveReport = $(modalId).find('#drive_report');
        let modeVal = $(this).val();
        // ボタン活性制御
        $('[id^="' + modalIdText + '-drive_report-mode_"]').removeClass('active');
        $(modalId + '-drive_report-mode_' + modeVal).addClass('active');
        // 表示パーツ切替 by mode
        driveReport.find('.mode-parts').addClass('d-none');
        driveReport.find('.mode-parts input[type="text"]').val('');
        driveReport.find('.mode-parts-' + modeVal).removeClass('d-none');

        // 月合計、車両のみの表示項目
        if (modeVal === 'vehicle') {
            driveReport.find('.total-vehicle-parts').removeClass('d-none');
        } else {
            driveReport.find('.total-vehicle-parts').addClass('d-none');
        }
    });

    /*---- drive_report date_type(monthly/range)選択時 ----*/

    $(document).off('change', '[id^="' + modalIdText + '-drive_report-date_type"]');
    $(document).on('change', '[id^="' + modalIdText + '-drive_report-date_type"]', function()
    {
        let driveReport = $(modalId).find('#drive_report');
        let dateTypeVal = $(this).val();

        // 表示パーツ切替 by date_type
        driveReport.find('.date_type-parts').addClass('d-none');
        driveReport.find('.date_type-parts-' + dateTypeVal).removeClass('d-none');
    });

    /*---- drive_report date_type=range 検索期間自動補完 ----*/

    $(document).off('change', modalId + '-drive_report-started_at,' + modalId + '-drive_report-started_at');
    $(document).on('change', modalId + '-drive_report-started_at,' + modalId + '-drive_report-started_at', function()
    {
        let modelId = $(modalId + '-model option:selected').val();
        dateRange_changeStartedAt(this, modalId + '-' + modelId + '-ended_at', 0, monthLimit[modelId]);
    });

    /*---- daily_check_result 検索期間自動補完 ----*/

    $(document).off('change', modalId + '-daily_check_result-started_at');
    $(document).on('change', modalId + '-daily_check_result-started_at', function()
    {
        dateRange_changeStartedAt(this, modalId + '-daily_check_result-ended_at', 0, monthLimit['daily_check_result']);
    });

    $(document).off('change', modalId + '-daily_check_result-ended_at');
    $(document).on('change', modalId + '-daily_check_result-ended_at', function()
    {
        dateRange_changeEndedAt(this, modalId + '-daily_check_result-started_at', 0, monthLimit['daily_check_result']);
    });

    /*---- refuel 検索期間自動補完 ----*/

    $(document).off('change', modalId + '-refuel-started_at');
    $(document).on('change', modalId + '-refuel-started_at', function()
    {
        dateRange_changeStartedAt(this, modalId + '-refuel-ended_at', 0, monthLimit['refuel']);
    });

    $(document).off('change', modalId + '-refuel-ended_at');
    $(document).on('change', modalId + '-refuel-ended_at', function()
    {
        dateRange_changeEndedAt(this, modalId + '-refuel-started_at', 0, monthLimit['refuel']);
    });

    /*---- refuel csv_type選択時 ----*/

    $(document).off('change', '[id^="' + modalIdText + '-refuel-csv_type"]');
    $(document).on('change', '[id^="' + modalIdText + '-refuel-csv_type"]', function()
    {
        let refuel = $(modalId).find('#refuel');
        // タイプ切替
        let type = $(this).val() === 'all' ? 'all' : 'monthly';
        refuel.find('input[name="type"]').val(type);
        // 表示パーツ切替 by type
        refuel.find('.type-parts').addClass('d-none');
        refuel.find('.type-parts input[type="text"]').not('.date-picker').not('.month-picker').val('');
        refuel.find('.type-parts-'+ type).removeClass('d-none');
        // 表示パーツ切替 by mode
        if (type === 'monthly') {
            let mode = $('#refuel input[name="mode"]').val();
            refuel.find('.mode-parts').addClass('d-none');
            refuel.find('.mode-parts input[type="text"]').val('');
            refuel.find('.mode-parts-' + mode).removeClass('d-none');
        } else {
            refuel.find('.mode-parts').removeClass('d-none');
            refuel.find('.mode-parts input[type="text"]').val('');
        }
    });

    /*---- refuel mode(user/vehicle)選択時 ----*/

    $(document).off('change', '#refuel input[name="mode"]');
    $(document).on('change', '#refuel input[name="mode"]', function()
    {
        // drive_report,attendance,refuelのmodeとパラメタ名が同じため、
        // JSのiconボタン共通ロジックでイベントが発火する為、 modelがrefuelの時のみ処理するようにする。
        let modelId = $(modalId + '-model option:selected').val();
        if (modelId !== 'refuel') {
            return;
        }
        let refuel = $(modalId).find('#refuel');
        // ボタン活性制御
        let mode = $(this).val();
        $('[id^="' + modalIdText + '-refuel-mode_"]').removeClass('active');
        $(modalId + '-refuel-mode_' + mode).addClass('active');
        // 表示パーツ切替 by mode
        refuel.find('.mode-parts').addClass('d-none');
        refuel.find('.mode-parts input[type="text"]').val('');
        refuel.find('.mode-parts-' + mode).removeClass('d-none');
    });

    /*---- attendance csv_type選択時 ----*/

    $(document).off('change', '[id^="' + modalIdText + '-attendance-csv_type"]');
    $(document).on('change', '[id^="' + modalIdText + '-attendance-csv_type"]', function()
    {
        let attendance = $(modalId).find('#attendance');
        // タイプ切替(1:monthly.list,2:monthly.detail,4:monthly.detail_all,3:yearly.list)
        let csvTypeVal = $(this).val();
        let mode = (csvTypeVal === '3' ? 'year' : 'month');
        attendance.find('input[name="mode"]').val(mode);
        // 表示パーツ切替 by mode
        attendance.find('.mode-parts').addClass('d-none');
        attendance.find('.mode-parts input[type="text"]').not('.month-picker').not('.year-picker').val('');
        attendance.find('.mode-parts-'+ mode).removeClass('d-none');
    });
}
